<template>
  <div class="component-body">
    <span class="title">管理类别</span>
    <div class="component-content">
      <el-tabs v-model="tabsName" class="el-tabs">
        <el-tab-pane label="视图" name="视图">
          <div class="select-searchmain1">
            <div class="earch-input">
              <div class="input-li2">
                <!-- <p>查询日期：</p> -->
                <el-date-picker
                  size="small"
                  style="width: 100%"
                  v-model="dates"
                  value-format="yyyy-MM"
                  type="monthrange"
                  :clearable="false"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
              </div>
              <div class="input-li">
                <!-- <p>选择辖区：</p> -->
                <el-select
                  size="small"
                  style="width: 100%"
                  v-model="searchParams.jurisdiction"
                  clearable
                  placeholder="请选择辖区"
                >
                  <el-option
                    v-for="item in jurisdictions"
                    :key="item.Key"
                    :label="item.Value"
                    :value="item.Key"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="search-action">
              <el-button
                size="small"
                icon="el-icon-search"
                type="primary"
                @click="getViews()"
                >查询</el-button
              >
              <!-- <el-button size="small" icon="el-icon-refresh" plain @click="onReset()">重置</el-button> -->
            </div>
          </div>
          <div class="chart-content">
            <div class="chart-card">
              <div class="chart-title">
                <div>管理类型统计</div>
                <el-radio-group
                  v-model="chartType"
                  @change="toogleChart"
                  size="small"
                >
                  <el-radio-button label="饼图"></el-radio-button>
                  <el-radio-button label="折线图"></el-radio-button>
                  <el-radio-button label="柱状图"></el-radio-button>
                </el-radio-group>
              </div>
              <div class="chart-main" id="manage-chart"></div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="列表" name="列表">
          <div class="select-searchmain2">
            <div class="earch-input">
              <div class="input-li">
                <p>企业名称</p>
                <el-input
                  size="small"
                  placeholder="请输入企业名称关键字"
                  v-model="tableSearchParams.name"
                >
                </el-input>
              </div>
              <div class="input-li">
                <p>统一社会信用代码</p>
                <el-input
                  size="small"
                  placeholder="请输入企业名称关键字"
                  v-model="tableSearchParams.code"
                >
                </el-input>
              </div>
              <div class="input-li">
                <p>选择辖区</p>
                <el-select
                  style="width: 100%"
                  size="small"
                  filterable
                  clearable
                  v-model="tableSearchParams.jurisdiction"
                  placeholder="请选择所在辖区"
                >
                  <el-option
                    v-for="item in jurisdiction"
                    :key="item.Key"
                    :label="item.Value"
                    :value="item.Key"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="input-li">
                <p>管理类别</p>
                <el-select
                  style="width: 100%"
                  size="small"
                  filterable
                  clearable
                  v-model="tableSearchParams.manageCategory"
                  placeholder="请选择管理类别"
                >
                  <el-option
                    v-for="item in manageCategory"
                    :key="item.Key"
                    :label="item.Value"
                    :value="item.Key"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="input-li">
                <p>行业类别</p>
                <el-cascader
                  placeholder="请选择行业类别"
                  ref="industryCas"
                  size="small"
                  clearable
                  :show-all-levels="false"
                  style="width: 100%"
                  collapse-tags
                  v-model="tableSearchParams.industry"
                  :props="industriesProps"
                  :options="industries"
                  filterable
                >
                </el-cascader>
              </div>
              <div class="input-li">
                <p>联系人</p>
                <el-input
                  size="small"
                  placeholder="请输入联系人"
                  v-model="tableSearchParams.wasteContact"
                >
                </el-input>
              </div>
              <div class="input-li2">
                <p>查询日期</p>
                <el-date-picker
                  size="small"
                  style="width: 100%"
                  v-model="tableDates"
                  value-format="yyyy-MM"
                  type="monthrange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
              </div>
            </div>
            <div class="search-action">
              <el-button size="small" plain @click="onReset()">重置</el-button>
              <el-button size="small" type="primary" @click="getList()"
                >查询</el-button
              >
              <el-button size="small" @click="downloadTable()">下载</el-button>
            </div>
          </div>
          <el-table
            size="small"
            height="calc(100% - 300px)"
            :header-cell-style="{
              background: '#f5f5f5',
              color: '#000',
            }"
            :data="dataSource"
            style="width: 100%; margin-bottom: 20px"
            row-key="id"
            border
          >
            <el-table-column align="center" label="序号" width="80">
              <template scope="scope">
                <span>{{
                  (pagination.current - 1) * pagination.pageSize +
                  scope.$index +
                  1
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="manageCategory"
              label="管理类别"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="name"
              label="企业名称"
              show-overflow-tooltip
            >
              <template slot-scope="{ row }">
                <span @click="detail(row)" class="company-name-link">{{
                  row.name
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="uniformSocialCreditCode"
              label="统一社会信用代码"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="jurisdiction"
              width="80"
              label="所属辖区"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="industry2017s"
              label="行业类别"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="wasteContact"
              width="100"
              label="联系人"
            >
            </el-table-column>
            <el-table-column align="center" prop="mobile" label="联系方式">
            </el-table-column>
          </el-table>
          <div class="paaination">
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pagination.current"
              :page-sizes="pagination.pageSizeOptions"
              :page-size="pagination.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pagination.total"
            >
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <companyDetail ref="companyDetail"></companyDetail>
  </div>
</template>

<script>
import * as echarts from "echarts";
import { paginations } from "@/../utils/public";
import { DownloadBlob } from "@/http/downloadService";
import companyDetail from "@/components/companyDetail.vue";

export default {
  components: { companyDetail },
  data() {
    return {
      tabsName: "视图",
      searchParams: {
        startDate: "",
        endDate: "",
        jurisdictions: null,
      },
      industriesProps: {
        multiple: false,
        value: "industryCode",
        label: "industryName",
        emitPath: false,
      },
      dataSource: [],
      tableSearchParams: {
        name: "",
        code: "",
        jurisdiction: null,
        manageCategory: null,
        industry: "",
        wasteContact: "",
      },
      pagination: {
        current: paginations.page,
        pageSize: paginations.limit,
        total: paginations.total,
        pageSizeOptions: paginations.pageSizes,
      },
      jurisdiction: [],
      manageCategory: [],
      industries: [],
      jurisdictions: [],
      chartType: "饼图",
      dates: [],
      tableDates: [],
      pieData: [],
      barData: [],
    };
  },
  methods: {
    downloadTable() {
      let url = this.$api.statistics.downloadManageCategoryList;

      const data = this.tableSearchParams;
      DownloadBlob({
        url: url,
        data: data,
        method: "get",
      });
    },
    detail(row) {
      this.$refs.companyDetail.getCompanyInfo(row);
    },
    toogleChart() {
      if (!document.getElementById("manage-chart")) return false;
      echarts.init(document.getElementById("manage-chart")).dispose();
      if (this.chartType == "饼图") {
        this.drawPieCharts();
      } else {
        this.drawBarCharts();
      }
    },

    getViews() {
      if (this.dates && this.dates.length > 0) {
        this.searchParams.startDate = this.dates[0];
        this.searchParams.endDate = this.dates[1];
      } else {
        this.searchParams.startDate = this.searchParams.endDate = null;
      }
      const params = {
        ...this.searchParams,
      };
      const url = this.$api.statistics.getManageCategoryView;
      this.$axios.get(url, params, false).then((res) => {
        if (res.data.code == 0) {
          let { pieData, barData, categories, jurisdictions } = res.data.data;

          if (this.jurisdictions.length <= 0)
            this.jurisdictions = jurisdictions;

          this.pieData = pieData;
          this.barData = barData;
          this.toogleChart();
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },

    drawPieCharts() {
      const colors = {
        重点监管: "#AE3D2E",
        简化管理: "#FEF757",
        登记管理: "#5594DF",
      };
      let pieData = this.pieData;

      let option = {
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            // 获取数据
            const data = pieData[params.dataIndex];
            let jurisdictions = data.jurisdictions;
            if (jurisdictions == null) return "";
            let thColor = "#fff";
            if (params.name == "简化管理") {
              thColor = "#808080";
            }
            // 构建tooltip内容
            let tooltipContent =
              '<div> <table style="text-align:center;border-collapse: collapse;">'; // 设置表格边框折叠
            tooltipContent +=
              '<tr style="background-color:' +
              params.color +
              ";color:" +
              thColor +
              '">';
            tooltipContent +=
              '<th style="border: 1px solid ' +
              params.color +
              '; padding: 5px;">辖区</th>'; // 设置表头边框和内边距
            tooltipContent +=
              '<th style="border: 1px solid ' +
              params.color +
              '; padding: 5px;">数量（家）</th>'; // 设置表头边框和内边距
            tooltipContent += "</tr>";
            jurisdictions.forEach(function (jurisdiction) {
              tooltipContent += "<tr>";
              tooltipContent += `<td style="border: 1px solid ${params.color}; padding: 5px;">${jurisdiction.jurisdiction}</td>`; // 设置单元格边框和内边距
              tooltipContent += `<td style="border: 1px solid ${params.color}; padding: 5px;">${jurisdiction.count}</td>`; // 设置单元格边框和内边距
              tooltipContent += "</tr>";
            });
            tooltipContent += "</table></div>";
            let title = `<div style="margin-bottom:7px"> ${params.marker}  ${data.name} : ${data.value} 家 </div> `;
            return `${title}  ${tooltipContent}`;
          },
        },
        legend: {
          top: "5%",
          left: "center",
        },
        graphic: {
          type: "text", // 类型：文本
          left: "center",
          top: "middle",
          silent: true, // 不响应事件
          invisible: pieData.length > 0, // 有数据就隐藏
          style: {
            fill: "#9d9d9d",
            fontWeight: "bold",
            text: "暂无数据",
            fontFamily: "Microsoft YaHei",
            fontSize: "25px",
          },
        },
        series: [
          {
            type: "pie",
            radius: ["35%", "55%"],
            avoidLabelOverlap: false,
            itemStyle: {
              normal: {
                color: function (params) {
                  return colors[params.name];
                },
              },
            },
            label: {
              show: true,
              normal: {
                formatter: "{b}\n \n \t{c} 家",
                textStyle: {
                  fontSize: 14,
                },
              },
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 16,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: true,
              // length2: 50,
              // length: 20,
              // lineStyle: {
              //   color: '#000'
              // }
            },
            data: pieData,
          },
        ],
      };
      const myChart = echarts.init(document.getElementById("manage-chart"));
      myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },

    drawBarCharts() {
      let chartType = this.chartType == "柱状图" ? "bar" : "line";

      const convertedData = [];
      this.barData.forEach((obj) => {
        const convertedObj = { date: obj.date };
        obj.monthData.forEach((item) => {
          convertedObj[item.name] = item.value;
          convertedObj[item.name + "辖区"] = item.jurisdictions;
        });
        convertedData.push(convertedObj);
      });

      const data = convertedData;
      let option = {
        color: ["#AE3D2E", "#FEF757", "#5594DF"],
        // title: {
        //   text: '危废数据'
        // },
        graphic: {
          type: "text", // 类型：文本
          left: "center",
          top: "middle",
          silent: true, // 不响应事件
          invisible: data.length > 0, // 有数据就隐藏
          style: {
            fill: "#9d9d9d",
            fontWeight: "bold",
            text: "暂无数据",
            fontFamily: "Microsoft YaHei",
            fontSize: "25px",
          },
        },
        legend: {},
        // toolbox: {
        //   feature: {
        //     // dataView: { show: true, readOnly: false },
        //     magicType: {            //动态类型切换
        //       show: true,           //是否显示该工具
        //       type: ['line', 'bar', 'stack'], //启用的动态类型
        //       title: {
        //         line: '切换为折线图',
        //         bar: '切换为柱状图',
        //         stack: "切换为堆叠"
        //       }
        //     },
        //     restore: { show: true, title: "还原" },
        //     // saveAsImage: { show: true }
        //   }
        // },
        tooltip: {
          // trigger: 'axis',
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
          formatter: function (params) {
            var jurisdictions = params.data[params.seriesName + "辖区"];

            if (jurisdictions == null) {
              return "";
            }
            let thColor = "#fff";
            let color = params.color;
            let title = "<div style='margin-bottom:5px'>";

            title += `<div>${params.marker} ${params.seriesName}：${
              params.value[params.seriesName]
            } 家 </div>`;

            title += "</div>";

            // 构建tooltip内容
            let tooltipContent =
              '<div style=""> <table style="text-align:center;border-collapse: collapse;">'; // 设置表格边框折叠
            tooltipContent +=
              '<tr style="background-color:' +
              color +
              ";color:" +
              thColor +
              '">';
            tooltipContent +=
              '<th style="border: 1px solid ' +
              color +
              '; padding: 5px 10px;">辖区</th>';

            // 设置表头边框和内边距
            tooltipContent +=
              '<th style="border: 1px solid ' +
              color +
              '; padding: 5px 10px;">个数（家）</th>'; // 设置表头边框和内边距

            tooltipContent += "</tr>";
            jurisdictions.forEach((jurisdiction) => {
              tooltipContent += "<tr>";
              tooltipContent += `<td style="border: 1px solid ${color}; padding: 5px 10px;">${jurisdiction.jurisdiction}</td>`; // 设置单元格边框和内边距
              tooltipContent += `<td style="border: 1px solid ${color}; padding: 5px 10px;">${jurisdiction.count} </td>`; // 设置单元格边框和内边距

              tooltipContent += "</tr>";
            });
            tooltipContent += "</table></div>";

            return `<div> ${title} ${tooltipContent}</div>`;
          },
        },

        dataset: {
          dimensions: ["date", "重点监管", "简化管理", "登记管理"],
          source: data,
        },
        xAxis: {
          type: "category",
          splitLine: {
            show: false,
          },
          axisPointer: {
            type: "shadow",
          },
          axisLabel: {
            show: true,

            rotate: 40,
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            formatter: "{value} 家",
          },
          minInterval: 1,
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            type: chartType,
            smooth: true,
          },
          {
            type: chartType,
            smooth: true,
          },
          {
            type: chartType,
            smooth: true,
          },
        ],
      };
      const myChart = echarts.init(document.getElementById("manage-chart"));
      myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },

    // getIndustry2017sName(data) {
    //   return data.map(d => d.industryName).join('，');
    // },
    getList() {
      if (this.tableDates && this.tableDates.length > 0) {
        this.tableSearchParams.startDate = this.dates[0];
        this.tableSearchParams.endDate = this.dates[1];
      } else {
        this.tableSearchParams.startDate = this.tableSearchParams.endDate =
          null;
      }
      const parames = {
        ...this.tableSearchParams,
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.current,
        getTotal: true,
      };
      const url = this.$api.statistics.getManageCategoryList;
      this.$axios.get(url, parames, false).then((res) => {
        if (res.data.code == 0) {
          let { data, total } = res.data.data;

          this.pagination.total = total;
          this.dataSource = data;
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },

    getParams() {
      const url = this.$api.companies.getParams;
      this.$axios.get(url, false).then((res) => {
        if (res.data.code == 0) {
          let { jurisdiction, manageCategory, industries } = res.data.data;
          this.jurisdiction = jurisdiction;
          this.manageCategory = manageCategory;
          this.industries = industries;
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },

    // 分页切换方法
    onPage(current, pageSize) {
      this.pagination.current = current;
      this.pagination.pageSize = pageSize;
      this.getList();
    },

    onReset() {
      this.pagination = {
        current: paginations.page,
        pageSize: paginations.limit,
        total: paginations.total,
        pageSizeOptions: paginations.pageSizes,
      };
      // 重置时清空搜索数据
      this.tableSearchParams = {
        name: "",
        code: "",
        jurisdiction: null,
        manageCategory: null,
        industry: "",
        wasteContact: "",
      };
      this.getList();
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getList();
    },
  },

  mounted() {
    // 获取当前年份和月份
    const currentMonth = this.$dayjs().format("YYYY-MM");
    // 获取上个月的年份和月份
    const lastMonth = this.$dayjs().subtract(1, "month").format("YYYY-MM");

    this.dates.push(lastMonth, currentMonth);
    this.tableDates.push(lastMonth, currentMonth);
    this.getViews();
    this.getParams();
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.company-name-link {
  color: #1890ff;
  cursor: pointer;
}
.component-body {
  height: 100%;

  .title {
    font-size: 18px;
    font-weight: bold;
    border-left: 8px solid #1890ff;
    padding-left: 12px;
  }

  .date-select {
    padding-bottom: 5px;
  }

  .component-content {
    height: calc(100% - 21px);
    padding-top: 5px;
    padding: 5px 15px;

    .el-tabs {
      width: 100%;
      height: 100%;

      /deep/.el-tabs__content {
        height: calc(100% - 55px);

        .el-tab-pane {
          height: 100%;
        }
      }
    }

    .chart-content {
      // display: flex;
      // flex-wrap: wrap;
      height: calc(100% - 60px);

      .chart-card {
        border: 1px solid #909399;
        width: 94%;
        margin: 10px 3%;
        height: calc(100% - 30px);
        border-radius: 3px;

        .chart-title {
          width: 100%;

          height: 45px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          border-bottom: 1px solid #909399;
          padding: 0px 10px;
        }

        .chart-main {
          width: 100%;
          height: calc(100% - 45px);
        }
      }
    }
  }

  .select-searchmain1 {
    width: 100%;
    height: 50px;
    display: flex;
    padding: 5px;
    box-sizing: content-box;

    .search-action {
      display: inline-block;
      // width: 230px;
      margin-right: 10px;
      text-align: center;
      height: 100%;
      margin-right: 10px;
      // line-height: 70px;
    }

    .earch-input {
      flex-grow: 1;
      padding-left: 20px;

      p {
        width: 100%;
        height: 30px;
        line-height: 30px;
      }

      .input-li2 {
        margin-right: 20px;
        width: 350px;
        font-size: 12px;
        display: inline-block;

        .el-input {
          line-height: 40px;
        }
      }

      .input-li {
        margin-right: 20px;
        width: 200px;
        font-size: 12px;
        display: inline-block;

        .el-input {
          line-height: 40px;
        }
      }
    }
  }

  .select-searchmain2 {
    width: 100%;
    // height: 50px;
    display: flex;
    padding: 5px;
    box-sizing: content-box;

    .search-action {
      display: flex;
      flex-wrap: nowrap;
      text-align: center;
      height: 100%;
      margin-right: 10px;
      // line-height: 70px;
    }

    .earch-input {
      flex-grow: 1;
      // padding-left: 20px;

      p {
        width: 100%;
        height: 30px;
        line-height: 30px;
      }

      .input-li2 {
        margin-right: 20px;
        width: 350px;
        font-size: 12px;
        display: inline-block;

        .el-input {
          line-height: 40px;
        }
      }

      .input-li {
        margin-right: 20px;
        width: 200px;
        font-size: 12px;
        display: inline-block;

        .el-input {
          line-height: 40px;
        }
      }
    }
  }
}
</style>